import {configureStore} from "@reduxjs/toolkit";
import {persistReducer, persistStore} from "redux-persist";
import storage from "redux-persist/lib/storage";
import {combineReducers} from "redux";
import authReducer from "./authSlice";
import favoritesReducer from "./favoritesSlice";
import watchlistReducer from "./watchlistSlice";
import watchedReducer from "./watchedSlice";
import ratingsReducer from "./ratingsSlice";
import hiddenReducer from "./hiddenSlice";
import filtersReducer from "./filtersSlice";
import settingsReducer from "./settingsSlice";

const persistConfig = {
  key: "root",
  storage,
  // Auth is not persisted — Clerk is the source of truth via useUser()
  blacklist: ["auth"],
};

const rootReducer = combineReducers({
  auth: authReducer,
  favorites: favoritesReducer,
  watchlist: watchlistReducer,
  watched: watchedReducer,
  ratings: ratingsReducer,
  hidden: hiddenReducer,
  filters: filtersReducer,
  settings: settingsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({serializableCheck: {ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"]}}),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
